'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import { Button, TextPassage } from '../../index.js';
import { useVerticalImageGallery } from './VerticalImageGalleryProvider.js';
export const ProductVideoPlayer = (_a) => {
    var { videoSrc, imgSrc, instructionText = 'Click to play video', forceVideoToStop = false, index } = _a, rest = __rest(_a, ["videoSrc", "imgSrc", "instructionText", "forceVideoToStop", "index"]);
    const [isPlaying, setIsPlaying] = useState(false);
    const { activeTab } = useVerticalImageGallery() || {};
    const videoRef = useRef(null);
    const togglePlay = () => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
            }
            else {
                videoRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };
    useEffect(() => {
        if (videoRef.current) {
            if (activeTab !== index) {
                videoRef.current.pause();
                setIsPlaying(false);
            }
        }
    }, [activeTab, index]);
    useEffect(() => {
        if (videoRef.current) {
            if (forceVideoToStop) {
                videoRef.current.pause();
                setIsPlaying(false);
            }
        }
    }, [forceVideoToStop]);
    return (_jsxs("div", Object.assign({ className: "sparky-c-vertical-carrousel__video-container" }, { children: [!isPlaying && (_jsx(Button, { className: "sparky-c-vertical-carrousel__play-button", variant: "link", onClick: togglePlay, iconName: "play-main", iconSize: "5xl" })), _jsx("video", Object.assign({ ref: videoRef, poster: imgSrc, src: videoSrc, controls: isPlaying, className: "sparky-c-vertical-carrousel__video" }, rest)), instructionText && !isPlaying && (_jsx(TextPassage, Object.assign({ align: "center", className: "sparky-c-vertical-product-gallery__instructions" }, { children: instructionText })))] })));
};
export default ProductVideoPlayer;
//# sourceMappingURL=ProductVideoPlayer.js.map